import { useEffect,useState } from '@wordpress/element';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import './editor.scss';
import InsSettings from './settings.js';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { borderStyle, borderRadiusStyle, VayuBlocksUniqueId, getResponsiveRangeValue} from '@vayu-blocks/global';
import {  MouseFollower } from '@vayu-blocks';
import classnames from 'classnames';
import {
  arrowLeft,
  arrowRight,
  chevronLeft,
  chevronRight,
  lock,
} from '@wordpress/icons';
 import { VayuBlockAdvanceStyle } from '@vayu-blocks/advance-panel/style.js';
export default function Edit(props) {
    const { attributes, setAttributes, clientId, isSelected } = props;
    const { mergedStyles, handleMouseEnter, handleMouseLeave, hoverAnimationClass } = VayuBlockAdvanceStyle(attributes);
    const { id } = attributes;

    const deviceView = VayuBlocksDevice();

    VayuBlocksUniqueId({ setAttributes, clientId });

    const innerBlocksProps = useInnerBlocksProps(
        { className: 'swiper-wrapper swipe-carousel' },
        {
            allowedBlocks: ['vayu-blocks/slide-item'],
            directInsert: true,
            orientation: 'horizontal',
            template: [
                ['vayu-blocks/slide-item', {}],
                ['vayu-blocks/slide-item', {}],
                 ['vayu-blocks/slide-item', {}],
                ['vayu-blocks/slide-item', {}],
            ],
            renderAppender: false,
        }
    );

const isDesktop = deviceView === 'Desktop';
const isTablet = deviceView === 'Tablet';
const isMobile = deviceView === 'Mobile';


const slideStyle = {
     ...mergedStyles,
    '--slideWidth': isDesktop ? (getResponsiveRangeValue(attributes.swipeslideWidth, 'Desktop')) :
                  isTablet ? (getResponsiveRangeValue(attributes.swipeslideWidth, 'Tablet')) :
                  isMobile ? (getResponsiveRangeValue(attributes.swipeslideWidth, 'Mobile')) :
                  '300px',
    '--slideStartGap': isDesktop ? (getResponsiveRangeValue(attributes.swipeStartGap, 'Desktop')) :
                  isTablet ? (getResponsiveRangeValue(attributes.swipeStartGap, 'Tablet')) :
                  isMobile ? (getResponsiveRangeValue(attributes.swipeStartGap, 'Mobile')) :
                  '90px',
    '--slideGap':isDesktop ? (getResponsiveRangeValue(attributes.swipeslideGap, 'Desktop')) :
                 isTablet ? (getResponsiveRangeValue(attributes.swipeslideGap, 'Tablet')) :
                 isMobile ? (getResponsiveRangeValue(attributes.swipeslideGap, 'Mobile')) :
                 '10px',
    '--navSize':isDesktop ? (attributes.swipeNavSize?.Desktop + 'px') :
                isTablet ? (attributes.swipeNavSize?.Tablet + 'px') :
                isMobile ? (attributes.swipeNavSize?.Mobile + 'px') :
                '14px',
    '--swipeNavPosition': isDesktop ? (attributes.swipeNavPostion?.Desktop + 'px') :
                       isTablet ? (attributes.swipeNavPostion?.Tablet + 'px') :
                       isMobile ? (attributes.swipeNavPostion?.Mobile + 'px') :
                       '0px',
    '--swipePagiSize': isDesktop ? (attributes.swipePagiSize?.Desktop + 'px') :
                     isTablet ? (attributes.swipePagiSize?.Tablet + 'px' ) :
                     isMobile ? (attributes.swipePagiSize?.Mobile + 'px') :
                     '10px',
    '--swipenavcolor': attributes.navcolor || '#111',
    '--swipenavbgcolor': attributes.navbgcolor || '#eee',
    '--swipepagicolor': attributes.pagicolor || '#eee',
    '--swipepagiActivecolor': attributes.pagiActivecolor || '#111',

};

let Classes = classnames(
    `swipe-scroll-wrapper swipe-feature-slider-wrapper`,{
    'th-hide-desktop': attributes.advResponsive?.Desktop === true,
    'th-hide-tablet': attributes.advResponsive?.Tablet === true,
    'th-hide-mobile': attributes.advResponsive?.Mobile === true,
  });

const blockProps = useBlockProps({
            className: Classes,
            style: slideStyle
});

const SlideBlockProps = {
		...blockProps,
		onMouseEnter: handleMouseEnter,
		onMouseLeave: handleMouseLeave,
	};

const [isInnerBlocksReady, setIsInnerBlocksReady] = useState(false);

useEffect(() => {
    const checkInnerBlocks = () => {
        const innerBlocks = document.querySelectorAll(`#block-${clientId} .wp-block-vayu-blocks-slide-item`);
        if (innerBlocks.length > 0) {
            setIsInnerBlocksReady(true);
        } else {
            setTimeout(checkInnerBlocks, 100);
        }
    };

    checkInnerBlocks();
}, [clientId]);

useEffect(() => {
    if (!isInnerBlocksReady) return;

    const checkElementsAndInit = () => {
        const wrappers = document.querySelectorAll(".swipe-scroll-wrapper[id^='block-']");
        const nav = attributes.swipeNav;

        wrappers.forEach((wrapper) => {
            //initSwipeFeatureSlider(wrapper, nav);
        });
    };

    checkElementsAndInit();
}, [isInnerBlocksReady, attributes.swipeNav]);

    const iconMap = {
        arrowLeft,
        arrowRight,
        chevronLeft,
        chevronRight,
        lock,
     };

    const lefticon = iconMap[attributes.swipeNavIconLeft] || null;
    const righticon = iconMap[attributes.swipeNavIconRight] || null;
    
    return (
        <>
            {isSelected && <InsSettings {...props} />}
            <div {...SlideBlockProps}>
                <div className="swipe-slider-content">
                <div {...innerBlocksProps} />
                {attributes.swipeNav === 'arrowdots' || attributes.swipeNav === 'dots' ? (
                <div className="pagination-container">
                        <span className="pagination-dot active" dataIndex="0">
                        </span>
                        <span className="pagination-dot" dataIndex="1">
                            </span><span className="pagination-dot" dataIndex="2">
                            </span><span className="pagination-dot" dataIndex="3">
                        </span>
                    </div>
                ): null}
                {attributes.swipeNav === 'arrowdots' || attributes.swipeNav === 'arrow' ? (
                    <>
                        {lefticon && <button className="scroll-button left" style={{
          ...borderStyle(attributes?.naviconsBorder, deviceView),
          ...borderRadiusStyle(attributes?.naviconsRadius, deviceView),
        }}>{lefticon}</button>}
                        {righticon && <button className="scroll-button right" style={{
          ...borderStyle(attributes?.naviconsBorder, deviceView),
          ...borderRadiusStyle(attributes?.naviconsRadius, deviceView),
        }}>{righticon}</button>}
                    </>
                ) : null}
                <MouseFollower value={attributes.advFollower} clientId={clientId}/>
                </div>
            </div>
        </>
    );
}

function initSwipeFeatureSlider(wrapper, nav) {
    const carousel = wrapper.querySelector(".swipe-carousel");
    if (!carousel || !wrapper) return;

    // CLEAN PREVIOUS CLONES
    carousel.querySelectorAll('.clone').forEach(clone => clone.remove());

    let items = Array.from(carousel.querySelectorAll(".wp-block-vayu-blocks-slide-item"));
    if (items.length === 0) return;

    let btnLeft, btnRight, paginationContainer;
    if (nav === 'arrow' || nav === 'arrowdots') {
        btnLeft = wrapper.querySelector(".scroll-button.left");
        btnRight = wrapper.querySelector(".scroll-button.right");
    }

    // Pagination setup
    paginationContainer = wrapper.querySelector(".pagination-container");
    if (nav === 'dots' || nav === 'arrowdots') {
        if (!paginationContainer) {
            paginationContainer = document.createElement("div");
            paginationContainer.classList.add("pagination-container");
            wrapper.appendChild(paginationContainer);
        } else {
            paginationContainer.innerHTML = ''; // Clear previous
        }
    } else {
        if (paginationContainer) {
            paginationContainer.remove();
            paginationContainer = null;
        }
    }

    let elementWidth = items[0].offsetWidth + 18;
    let visibleItems = Math.floor(wrapper.offsetWidth / elementWidth) || 1;
    let currentIndex = 0;
    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let dragThreshold = elementWidth * 0.3;

    // Prevent image dragging
    items.forEach((item) => {
        item.querySelectorAll("img").forEach((img) => {
            img.setAttribute("draggable", "false");
        });
    });

    // Add clones
    const clones = items.slice(0, visibleItems).map(item => {
        const clone = item.cloneNode(true);
        clone.classList.add("clone");
        carousel.appendChild(clone);
        return clone;
    });

    items = Array.from(carousel.querySelectorAll(".wp-block-vayu-blocks-slide-item"));

    // Pagination Dots
    if (paginationContainer) {
        items.slice(0, items.length - clones.length).forEach((_, index) => {
            const dot = document.createElement("span");
            dot.classList.add("pagination-dot");
            dot.dataset.index = index;
            paginationContainer.appendChild(dot);
        });
    }

    const updatePagination = () => {
        const realIndex = currentIndex % (items.length - clones.length);
        if (paginationContainer) {
            paginationContainer.querySelectorAll(".pagination-dot").forEach((dot, index) => {
                dot.classList.toggle("active", index === realIndex);
            });
        }
    };

    const scrollToIndex = (index, animate = true) => {
        currentIndex = index;
        if (currentIndex >= items.length - clones.length) {
            currentIndex = 0;
            currentTranslate = 0;
        } else if (currentIndex < 0) {
            currentIndex = items.length - clones.length - 1;
            currentTranslate = -currentIndex * elementWidth;
        }
        currentTranslate = -currentIndex * elementWidth;
        prevTranslate = currentTranslate;
        carousel.style.transform = `translateX(${currentTranslate}px)`;
        carousel.style.transition = animate ? "transform 0.4s ease" : "none";
        updatePagination();
    };

    // Drag functions
    const getPositionX = (e) => e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
    const dragStart = (e) => {
        e.preventDefault();
        isDragging = true;
        startPos = getPositionX(e);
        prevTranslate = currentTranslate;
        carousel.style.transition = "none";
        carousel.classList.add("dragging");
    };
    const dragMove = (e) => {
        if (!isDragging) return;
        const diff = getPositionX(e) - startPos;
        currentTranslate = prevTranslate + diff;
        const maxTranslate = 0;
        const minTranslate = -((items.length - visibleItems) * elementWidth);
        if (currentTranslate > maxTranslate) {
            currentTranslate = maxTranslate + (currentTranslate - maxTranslate) * 0.5;
        } else if (currentTranslate < minTranslate) {
            currentTranslate = minTranslate + (currentTranslate - minTranslate) * 0.5;
        }
        carousel.style.transform = `translateX(${currentTranslate}px)`;
    };
    const dragEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        carousel.classList.remove("dragging");
        const movedBy = currentTranslate - (-currentIndex * elementWidth);
        let newIndex = currentIndex;
        if (Math.abs(movedBy) > dragThreshold) {
            newIndex += movedBy > 0 ? -1 : 1;
        }
        scrollToIndex(newIndex);
    };

    carousel.addEventListener("mousedown", dragStart);
    carousel.addEventListener("touchstart", dragStart, { passive: false });
    carousel.addEventListener("mousemove", dragMove);
    carousel.addEventListener("touchmove", dragMove, { passive: false });
    carousel.addEventListener("mouseup", dragEnd);
    carousel.addEventListener("touchend", dragEnd);
    carousel.addEventListener("mouseleave", dragEnd);

    if (btnLeft) btnLeft.addEventListener("click", () => scrollToIndex(currentIndex - 1));
    if (btnRight) btnRight.addEventListener("click", () => scrollToIndex(currentIndex + 1));

    if (paginationContainer) {
        paginationContainer.addEventListener("click", (e) => {
            if (e.target.classList.contains("pagination-dot")) {
                scrollToIndex(parseInt(e.target.dataset.index, 10));
            }
        });
    }

    const handleResize = () => {
        elementWidth = items[0]?.offsetWidth + 18 || 0;
        visibleItems = Math.floor(wrapper.offsetWidth / elementWidth) || 1;
        dragThreshold = elementWidth * 0.3;
        scrollToIndex(currentIndex, false);
    };
    window.addEventListener("resize", handleResize);

    scrollToIndex(0);
}

